const router = [
    {
        path: '/company',
        name: 'companyModule',
        redirect: '/company/welcome-email',
        component: () => import('@/modules/Company/pages'),
        children: [
            {
                path: '/company/welcome-email',
                name: 'SendWelcomeEmail',
                component: () => import('@/modules/Company/pages/SendWelcomeEmail'),
                meta: {
                    requiresAuth: true,
                    requiresPermission: true,
                    action: 110
                }
            },
            {
                path: '/company/process-manager',
                name: 'ProcessManager',
                component: () => import('@/modules/Company/pages/ProcessManager'),
                meta: {
                    requiresAuth: true,
                    requiresPermission: true,
                    action: 5
                }
            },
            {
                path: '/company/payroll-config',
                name: 'PayrollConfig',
                component: () => import('@/modules/Company/pages/PayrollConfig'),
                meta: {
                    requiresAuth: true,
                    requiresPermission: true,
                    action: 'payroll'
                }
            }
        ],
        meta: {
            requiresAuth: true,
            requiresPermission: false
        }
    }
]
export default router